<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        Login Process through QR </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>Introduction </h2>
                    <label for="" class="mt-2">This document provides a step-by-step guide for directly logging into the
                        PayG Sales Partner account on the web through QR scanning. Follow the instructions carefully to
                        ensure a smooth setup process. </label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-2"><b>Step 1: Download the PayG RMS App </b></h4>
                    <label for="">To begin, you must download the PayG RMS App on your mobile phone. The
                        app is available for both Android and IOS devices</label>
                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/reseller(1).svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4"><b>For Android Users:</b></h4>
                    <div class="row">
                        <label for=""><b>Download Link :</b> Click <a
                                style="text-decoration: none; color: rgb(4, 151, 242);"
                                href="https://play.google.com/store/apps/details?id=com.paygdigitals.rms&hl=en">
                                https://play.google.com/store/apps/details?id=com.paygdigitals.rms&hl=en</a> to access
                            the Google Play Store and download the PayG RMS App. </label>
                            <h4 class="mt-4"><b>For iOS Users: </b></h4>
                        <div class="row">
                            <label for=""><b>Download Link :</b> Click <a
                                    style="text-decoration: none; color: rgb(4, 151, 242);"
                                    href="https://apps.apple.com/us/app/payg-rms/id6463256232">
                                    https://apps.apple.com/us/app/payg-rms/id6463256232</a> to access the App Store and
                                download the PayG RMS App. </label>



                        <h4 class="mt-4"><b>QR Code </b></h4>
                        <label for="">Scan the QR code below using your device’s camera or a QR code scanner app to be
                            directed to the Play Store or App store </label>
                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/QR code both.svg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        
                            <!-- <h4 class="mt-4"><b>QR Code </b></h4>
                            <label for="">Scan the QR code below using your device’s camera or a QR code scanner app to
                                be directed to the App Store </label>
                            <div class="row">
                                <div class="col-md-12 mt-3" style="text-align: center;">
                                    <img src="./assets/RMS_PayG_ iOS_QR.png" width="200px" height="200px"
                                        alt="">
                                </div>
                            </div> -->

                        </div>
                        <h4 class="mt-4"><b>Step 2: Open the App and Log In</b></h4>
                        <label for="">Once the app is successfully downloaded, locate the PayG RMS app on your mobile
                            device and tap to open it. </label>
                        <label for=""><b>Login:</b> Enter your user credentials (username and password) in the
                            designated fields. Ensure your information is entered correctly to avoid login issues.
                        </label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(4).svg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>Step 3: Access the Profile Section</b></h4>
                        <label for="">After logging in, you will be directed to the mobile app dashboard. Look for the
                            profile icon, typically located on the left-hand side of the dashboard. </label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(5).svg" width="300px" height="500px" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>Step 4: Select Web Scanner to Login</b></h4>
                        <label for="">Web Scanner Option: Locate and select the “Web Scanner to Login” option. This
                            feature allows you to log in to the web by scanning the QR code. </label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(6).svg" width="300px" height="500px" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>Step 5: Scan the QR Code</b></h4>
                        <h4>To complete the login process on the web platform: </h4>
                        <label for="">Position your mobile device's camera over the QR code displayed on the web page.
                            Make sure the QR code is well centered in the camera’s viewfinder for optimal scanning.
                        </label>
                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/qr scna.svg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <label class="mt-3" for="">Once the QR code is successfully scanned, you will be automatically logged into
                            the PayG RMS web platform, allowing you to access all available functionalities. </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/reseller(8).svg" width="100%"
                                    height="100%" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4">Conclusion </h4>
                        <label for="">You have completed the initial setup and login process for the PayG RMS App. If
                            you encounter any issues during this process, please consult the support section of the app
                            or contact customer support for further assistance. </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <div class="col-md-4 hide-tbl content2 ">
            <div class="card crd p-4">
                <div class="row">
                    <div class="col-md-12">
                        <h5>
                            Table of Contents:
                        </h5>

                    </div>
                    <div class="col-md-12 mt-2">
                        <!-- <a href="#1">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                        alt=""> &nbsp;</div>
                                <div class="col-md-10">
                                    <span class="videoHover" style="cursor: pointer;"
                                        [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                        >
                                        Introduction to
                                        Payment Gateways
                                    </span>
                                  
                                </div>
                            </div>
                        </a> -->
                    </div>
                    <div class="col-md-12 ">
                        <a href="#2">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                        (click)="color('2')">Introduction  </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 ">
                        <a href="#3">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                        (click)="color('3')">
                                        Login Process </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="col-md-12 ">
                        <a href="#4">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">Benefits of Being a Reseller </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 ">
                        <a href="#5">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                        (click)="color('5')"> How Resellers Can Benefit from PayG</span>

                                </div>
                            </div>
                        </a>
                    </div> -->

                </div>
            </div>
        </div>
        <div class="col-md-9 hide ft-9">
            <hr>
            <div class=" row crd">
                <div class="col-md-8    ">
                    <a [routerLink]="['/registration-process']"><button class="btn btn-color"
                            (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt="">
                            &nbsp;Registration Process
                            &nbsp;</button></a>
                </div>
                <div class="col-md-4    ">
                    <a [routerLink]="['/manual-login']"> <button class="btn btn-color">Manual Login 
                            &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                </div>
            </div>
        </div>
</div>